import React from "react"
import PropTypes from "prop-types"
import clsx from "clsx"

// Material UI
import { makeStyles } from "@material-ui/core/styles"
import Select from "@material-ui/core/Select"

const useStyles = makeStyles(theme => ({
  white: {
    backgroundColor: theme.palette.common.white,
    "&:focus": {
      backgroundColor: theme.palette.common.white
    }
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}))

export default function CustomSelect({ children, ...props }) {
  const classes = useStyles()

  return (
    <Select
      className={clsx({
        [classes.selectEmpty]: props.displayEmpty
      })}
      classes={{
        outlined: classes.white,
        filled: classes.white
      }}
      {...props}
    >
      {children}
    </Select>
  )
}

CustomSelect.propTypes = {
  children: PropTypes.any,
  displayEmpty: PropTypes.bool
}
